import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";

import { Grid, Paper } from "@mui/material";
import {
  format,
  addDays,
  lastDayOfWeek,
  getWeek,
  addWeeks,
  subWeeks,
  subDays,
} from "date-fns";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import "react-datepicker/dist/react-datepicker.css";
import WeekPicker from "components/UI/TimeSheetWeekTimePicker";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: "20px 20px 0px 20px",
      width: theme.spacing(16),
      height: "auto",
    },
  },
  paper: {
    width: "100%",
  },
  calender: {
    float: "right",
    margin: "0px 0px",
  },
  heading: {
    marginLeft: "20px",
  },
  layout: {
    margin: "40px 20px",
  },
  icon: {
    border: "1px solid #ADD8E6",
    padding: "5px",
    color: "#0000FF",
  },
  Dateicon: {
    display: "inline-block",
    border: "1px solid #ADD8E6",
    padding: "5px",
    color: "#0000FF",
  },
  view: {
    padding: "5px",
    width: "120px",
  },
  week: {
    color: "#0000FF",
    textTransform: "uppercase",
    fontWeight: "600",
    fontSize: "18px",
  },
  day: {
    color: "#000000c9",
    fontSize: "24px",
  },
  main: {
    background: "#8080802b",
    padding: "0px 20px",
  },
}));

export default function WeeklyDates({
  setDatesList,
  setEndDate,
  date,
  setDate,
}) {
  const classes = useStyles();
  const [currentMonth, setCurrentMonth] = useState(date);
  const [currentWeek, setCurrentWeek] = useState(getWeek(currentMonth));

  const ary = [];

  console.log(currentWeek);

  const changeWeekHandle = (btnType) => {
    if (btnType === "prev") {
      setDate((date) => {
        return subDays(date, 7);
      });
      setCurrentMonth(subWeeks(currentMonth, 1));
      setCurrentWeek(getWeek(subWeeks(currentMonth, 1)));
    }
    if (btnType === "next") {
      setDate((date) => {
        return addDays(date, 7);
      });
      setCurrentMonth(addWeeks(currentMonth, 1));
      setCurrentWeek(getWeek(addWeeks(currentMonth, 1)));
    }
  };

  const getFormattedDate = (date) => {
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    return month + "/" + day + "/" + year;
  };

  const renderCells = () => {
    const endDate = lastDayOfWeek(currentMonth, { weekStartsOn: 0 });
    const formateEndDate = getFormattedDate(endDate);
    const eDate = formateEndDate.toString();
    setEndDate(eDate);

    const dateFormat = "d ";
    const dateFormatMonth = " MMM ";
    const dateFormatWeek = "EEE";
    const rows = [];
    let days = [];
    let day = date;
    let formattedDate = "";
    let formattedDateMonth = "";
    let formattedDateWeek = "";
    // while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      const fDay1 = getFormattedDate(day);
      const fDay2 = fDay1.toString();
      formattedDate = format(day, dateFormat);
      formattedDateMonth = format(day, dateFormatMonth);
      formattedDateWeek = format(day, dateFormatWeek);
      const finalDate =
        `${formattedDateWeek},${formattedDate}${formattedDateMonth}`
          .split(" ")
          .join("");

      let obj = {
        day: formattedDateWeek,
        timesheet_date: fDay2,
        day_date: finalDate,
        client_name: "",
        project_name: "",
        task_name: "",
        project_ary: [""],
        task_ary: [""],
        notes: "",
        check_in_time: "00:00",
        check_out_time: "00:00",
        check_in_check_out_time: 0,
        break_hrs: 0,
        total_hrs: 0,
        non_billable_hrs: 0,
        work_hrs: 0,
      };

      ary.push(obj);

      days.push(
        <div
          key={day}
          className={classes.view}
          style={{ display: "inline-block" }}
        >
          <div className={classes.week}>{formattedDateWeek}</div>
          <div className={classes.day}>{formattedDate}</div>
          <div>{formattedDateMonth}</div>
        </div>
      );
      day = addDays(day, 1);
    }
    rows.pop();
    rows.push(<div key={day}>{days}</div>);
    days = [];
    // }

    setDatesList(
      ary.map((p, index) => ({
        ...p,
        id: index,
      }))
    );

    return ary;
  };

  useEffect(() => {
    renderCells();
  }, [date]);

  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.paper} elevation={0}>
          <Grid container spacing={2}>
            <div className={classes.calender}>
              <div style={{ display: "inline-block", marginRight: "15px" }}>
                <KeyboardDoubleArrowLeftIcon
                  onClick={() => changeWeekHandle("prev")}
                  className={classes.icon}
                  fontSize="medium"
                />
              </div>
              <div style={{ display: "inline-block" }}>
                <WeekPicker date={date} setDate={setDate} />
              </div>
              <div style={{ display: "inline-block" }}>
                <KeyboardDoubleArrowRightIcon
                  onClick={() => changeWeekHandle("next")}
                  className={classes.icon}
                  fontSize="medium"
                />
              </div>
            </div>
          </Grid>
        </Paper>
      </div>
    </>
  );
}
